/* eslint-disable react/prop-types,jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */
import React from 'react'
import { withTranslation } from 'react-i18next'

import './ReportsPopover.scss'

class ReportsPopover extends React.Component {
  render() {
    const { t } = this.props
    return (
      <div
        className={`container mt-2 text-center ${
          this.props.fromSticky ? 'fix' : ''
        }`}
        id='ReportsPopover'
      >
        <h5>{t('profile.reportsPopover.title')}</h5>
        <hr />
        <p onClick={this._handlePlayerProgressClick}>
          {t('profile.common.juniorDevelopmentModel')}
        </p>
        <p onClick={this._handleJourneyClick}>
          {t('profile.reportsPopover.onCourseJourney')}
        </p>
      </div>
    )
  }

  _handlePlayerProgressClick = () => {
    this.props.togglePlayerProgressModal()
    this.props.toggleDropdown()
  }

  _handleJourneyClick = () => {
    this.props.toggleJourneyModal()
    this.props.toggleDropdown()
  }
}

export default withTranslation()(ReportsPopover)
